/*
 * Ein Widget folgt einem anderen (`follow`): Eine Wertkachel mit
 * abwechselnden Werten meldet hier die benannten Punkte (`links`) des Werts,
 * den sie gerade zeigt. Ein Widget mit `follow: '<id>'` nimmt diese Punkte
 * statt seiner eigenen gleichen Namens. So verstellen Plus und Minus auf der
 * Startseite den Sollwert des Heizkreises, dessen Raum die Kachel gerade
 * zeigt (Kutiak, 18.10.2026).
 */

import { signal, type Signal } from '@preact/signals';

const store = new Map<string, Signal<Record<string, string>>>();

function slot(widgetId: string): Signal<Record<string, string>> {
  let s = store.get(widgetId);
  if (!s) {
    s = signal<Record<string, string>>({});
    store.set(widgetId, s);
  }
  return s;
}

/** Die Kachel meldet die Punkte ihres gerade gezeigten Werts. */
export function publishFollow(widgetId: string, links: Record<string, string> | undefined): void {
  const s = slot(widgetId);
  const next = links ?? {};
  const prev = s.value;
  const same = Object.keys(prev).length === Object.keys(next).length
    && Object.entries(next).every(([k, v]) => prev[k] === v);
  if (!same) s.value = next;
}

/** Punkte eines Widgets mit denen der Kachel, der es folgt. Liest das Signal,
 *  also rendert der Aufrufer neu, wenn die Kachel weiterschaltet. */
export function followedPoints(
  points: Record<string, string> | undefined,
  follow: string | undefined,
): Record<string, string> | undefined {
  if (!follow) return points;
  const links = slot(follow).value;
  if (Object.keys(links).length === 0) return points;
  return { ...(points ?? {}), ...links };
}
